import {Injectable, signal, WritableSignal} from "@angular/core";
import {environment} from "../../../../../../environments/environment.development";
import {HttpClient} from "@angular/common/http";
import {TenenciaItem} from "../../../../interfaces/proyecto.interface";
import {AutorizacionesService} from "../../../../../officials/autorizaciones/services/autorizaciones.service";

import {Autorizaciones} from "../../../../../officials/autorizaciones/interfaces/autorizaciones-interface";
import {LoginServices} from "../../../../../auth/login/services/login.service";
import {TipoAutorizaciones} from "../../../../../shared/interfaces/shared-interface";
const apiVucUrl = environment.apiVucUrl
@Injectable({
    providedIn: 'root'
})
export class PasosPersonasService {
    autorizaciones: WritableSignal<Autorizaciones[]> = signal([])
    constructor(private http: HttpClient, private autorizacionesService: AutorizacionesService, private loginServices:LoginServices) {
    }
    getTenenciaList(estados:number[]) {
        return this.http.get<TenenciaItem[]>(apiVucUrl + `api/v1.0/tenencia/?estados=${estados}`)
    }

    getAutorizaciones(uniqueId:string) {
        let tipos:number[]=[TipoAutorizaciones.Titular];
        this.autorizacionesService.consultaAutorizaciones(uniqueId,tipos)
            .subscribe({
                next: (result) => {
                    this.autorizaciones.set(result.body!);
                },
                error: (error) => {
                },
                complete: () => {
                }
            });
    }
    /**
     * Este metodo permite obtener los datos del dropdown titulares de la DB y agregarle el usuario de la session*/
    actualizarJsonConPersonas() {
        console.log("actualizarJsonPersonas");
        const opcionesConstantes = [
            {
                key: this.loginServices.session()?.perfil.uniqueId!,
                value: this.loginServices.session()?.perfil.nombreCompleto!,
                estado: true,
                idRequisito: 0,
                tituloFile: "",
                tituloInfo: ""
            }
        ];
        let opciones = this.autorizaciones().map(persona => ({
            key: persona.uniqueId,
            value: `${persona.nombres} ${persona.apellidos==null?'':persona.apellidos}`,
            estado: true,
            idRequisito: 0,
            tituloFile: '',
            tituloInfo: ''
        }));
        const opcionesFinal = [...opciones, ...opcionesConstantes];
        return opcionesFinal;
    }

}
